<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Image from './Image.svelte';

    interface MediaFile {
        uuid: string;
        file_name?: string;
        file_path?: string;
        url?: string;
    }
    export let mediaFiles: MediaFile[] = [];
    export let editMode = false;

    const dispatch = createEventDispatcher();

    function handleDelete(uuid: string) {
        const index = mediaFiles.findIndex((file) => file.uuid === uuid);
        if (index !== -1) {
            mediaFiles.splice(index, 1);
            mediaFiles = [...mediaFiles];
            dispatch('delete', { uuid }); 
        }
    }    
</script>

<style>
.gallery-container {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 20px;
}
.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    width: 100px; 
    height: 100px; 
    position: relative;
    border: 1px solid #ddd; 
}
</style>
  
<div class="gallery-container">
    {#each mediaFiles as { uuid, file_name, file_path, url }}
        <div class="image-container">
            <Image src={url} alt={file_name} editMode={editMode} on:delete={() => handleDelete(uuid)} />
        </div>
    {/each}
</div>